export const route_roles = [
  { label: 'CFO', tone: 'teal' },
  { label: 'Compliance', tone: 'orange', suffix: 'RISK ROUTING' },
  { label: 'Internal Audit', tone: 'orange', suffix: 'RISK ROUTING' }
];

export const control_plane_routes = {
  Procurement: '/compliance-procurement',
  Finance: '/finance-compliance',
  Contracts: '/contract-lifecycle',
  Suppliers: '/supplier-register',
  Policies: '/compliance-policies',
  Incidents: '/incidents-cases',
  Risks: '/risks',
  Audits: '/audits',
  Workflows: '/workflows',
  'My Tasks': '/my-tasks',
  Governance: '/governance',
  Reports: '/reports'
};

export const control_plane_apps = [
  { label: 'Procurement', icon: 'bi-cart' },
  { label: 'Finance', icon: 'bi-credit-card-2-front' },
  { label: 'Contracts', icon: 'bi-file-earmark-text' },
  { label: 'Suppliers', icon: 'bi-truck' },
  { label: 'Policies', icon: 'bi-journal-text' },
  { label: 'Incidents', icon: 'bi-exclamation-triangle' },
  { label: 'Risks', icon: 'bi-exclamation-diamond' },
  { label: 'Audits', icon: 'bi-clipboard-check' },
  { label: 'Workflows', icon: 'bi-diagram-3' },
  { label: 'My Tasks', icon: 'bi-list-check' },
  { label: 'Governance', icon: 'bi-building' },
  { label: 'Reports', icon: 'bi-graph-up' }
].map((app) => ({
  ...app,
  route_path: control_plane_routes[app.label] || null
}));

export const live_decision_stats = [
  { label: 'Decisions routed', value: '6', note: 'Through the engine', accent: 'neutral' },
  { label: 'Within authority', value: '2', note: 'Chain satisfied', accent: 'green' },
  { label: 'Outside authority', value: '1', note: 'Escalated as exceptions', accent: 'red', tab_id: 'exception_log' },
  { label: 'Awaiting approval', value: '3', note: 'In the chain now', accent: 'amber' }
];

export const live_decision_rows = [
  {
    ref: 'DC-QHN',
    transaction: 'Procurement / PO - R 500 000 - R 5 000 000',
    amount: 'R 750 000',
    risk: 'High',
    risk_class: 'bg-danger-subtle text-danger-emphasis',
    required_chain: 'CFO + Compliance + Internal Audit',
    verdict: 'Awaiting approval',
    verdict_class: 'bg-warning-subtle text-warning-emphasis',
    drawer_key: 'dc_qhn'
  },
  {
    ref: 'DC-301',
    transaction: 'Contract award - Nexus managed-services agreement',
    amount: 'R 3 000 000',
    risk: 'High',
    risk_class: 'bg-danger-subtle text-danger-emphasis',
    required_chain: 'CFO + CEO + Compliance + Internal Audit',
    verdict: 'Awaiting approval',
    verdict_class: 'bg-warning-subtle text-warning-emphasis',
    drawer_key: 'dc_301',
    id_chip: { label: 'CTR-204', route_path: '/contract-lifecycle' }
  },
  {
    ref: 'DC-210',
    transaction: 'Purchase order - IT hardware (deviation)',
    amount: 'R 740 000',
    risk: 'Medium',
    risk_class: 'bg-warning-subtle text-warning-emphasis',
    required_chain: 'CFO + Compliance',
    verdict: 'Within authority',
    verdict_class: 'bg-success-subtle text-success-emphasis',
    drawer_key: 'dc_210',
    id_chip: { label: 'REQ-204', route_path: '/compliance-procurement' }
  },
  {
    ref: 'DC-118',
    transaction: 'Payment release - GreenBuild invoice',
    amount: 'R 420 000',
    risk: 'Low',
    risk_class: 'bg-success-subtle text-success-emphasis',
    required_chain: 'Executive (CFO)',
    verdict: 'Within authority',
    verdict_class: 'bg-success-subtle text-success-emphasis',
    drawer_key: 'dc_118',
    id_chip: { label: 'INV-2204', route_path: '/finance-compliance' }
  },
  {
    ref: 'DC-150',
    transaction: 'Platform support agreement renewal',
    amount: 'R 520 000',
    risk: 'Medium',
    risk_class: 'bg-warning-subtle text-warning-emphasis',
    required_chain: 'CFO + CEO',
    verdict: 'Outside authority',
    verdict_class: 'bg-danger-subtle text-danger-emphasis',
    drawer_key: 'dc_150',
    id_chip: { label: 'CTR-118', route_path: '/contract-lifecycle' }
  },
  {
    ref: 'DC-160',
    transaction: 'Data-sharing agreement - BlueData',
    amount: 'R 0',
    risk: 'High',
    risk_class: 'bg-danger-subtle text-danger-emphasis',
    required_chain: 'Line manager + Compliance + Internal Audit + Legal + Information Officer',
    verdict: 'Awaiting approval',
    verdict_class: 'bg-warning-subtle text-warning-emphasis',
    drawer_key: 'dc_160',
    id_chip: { label: 'DSA-01', route_path: '/data-privacy' }
  }
];

export const live_decision_drawers = {
  dc_qhn: {
    section: 'DECISION - DC-QHN',
    title: 'Procurement / PO - R 500 000 - R 5 000 000',
    subtitle: 'R 750 000 - Procurement / PO - routed just now',
    status: 'Awaiting approval',
    status_class: 'bg-warning-subtle text-warning-emphasis',
    chain_label: 'Required approver chain',
    chain_note: 'Band TH-10 (R 500 000 - R 5 000 000). Risk routing added: Compliance, Internal Audit.',
    chain: [
      { label: 'CFO', tone: 'teal' },
      { label: 'Compliance', tone: 'orange', suffix: 'RISK ROUTING' },
      { label: 'Internal Audit', tone: 'orange', suffix: 'RISK ROUTING' }
    ],
    verdict_title: 'Approval verdict',
    verdict_body: 'Actually approved by: -- not yet approved',
    verdict_tone: 'bg-warning-subtle text-warning-emphasis',
    trace_title: 'Routing trace - across modules',
    trace: [
      { title: 'Delegation of Authority', tag: 'TH-10', subtitle: 'Engine computed required chain: CFO + Compliance + Internal Audit' },
      { title: 'My Tasks', tag: 'Approval tasks', subtitle: 'Assigned to each required approver' },
      { title: 'Evidence vault', tag: 'Pending', subtitle: 'Approval record stored on sign-off' },
      { title: 'Reports', tag: 'Register', subtitle: 'Reported as within / outside authority' }
    ],
    footer_label: 'Open procurement / PO',
    footer_icon: 'bi-box-arrow-up-right'
  },
  dc_301: {
    section: 'DECISION - DC-301',
    title: 'Contract award - Nexus managed-services agreement',
    subtitle: 'R 3 000 000 - Contract value - routed today - 09:20',
    status: 'Awaiting approval',
    status_class: 'bg-warning-subtle text-warning-emphasis',
    chain_label: 'Required approver chain',
    chain_note: 'Band TH-13 (R 500 000 - R 5 000 000). Risk routing added: Compliance, Internal Audit.',
    chain: [
      { label: 'CFO', tone: 'teal' },
      { label: 'CEO', tone: 'teal' },
      { label: 'Compliance', tone: 'orange', suffix: 'RISK ROUTING' },
      { label: 'Internal Audit', tone: 'orange', suffix: 'RISK ROUTING' }
    ],
    verdict_title: 'Approval verdict',
    verdict_body: 'Actually approved by: -- not yet approved',
    verdict_tone: 'bg-warning-subtle text-warning-emphasis',
    trace_title: 'Routing trace - across modules',
    trace: [
      { title: 'Contract module', tag: 'CTR-204', subtitle: 'Value R 3 000 000 detected on upload - no manual approver chosen' },
      { title: 'Delegation of Authority', tag: 'TH-13 + risk routing', subtitle: 'Engine computed chain: CFO + CEO + Compliance + Internal Audit' },
      { title: 'Workflow', tag: 'WF-512', subtitle: 'Contract-approval workflow routes to Legal, finance & executive approval' },
      { title: 'My Tasks', tag: '4 approval tasks', subtitle: 'An approval task is assigned to each required approver' },
      { title: 'Evidence vault', tag: 'Pending sign-off', subtitle: 'Signed approval record is stored on final sign-off' },
      { title: 'Reports', tag: 'Board pack', subtitle: 'Reported as within / outside authority once decided' }
    ],
    footer_label: 'Open Nexus MSA',
    footer_icon: 'bi-box-arrow-up-right'
  },
  dc_210: {
    section: 'DECISION - DC-210',
    title: 'Purchase order - IT hardware (deviation)',
    subtitle: 'R 740 000 - Procurement / PO - routed yesterday - 14:02',
    status: 'Within authority',
    status_class: 'bg-success-subtle text-success-emphasis',
    chain_label: 'Required approver chain',
    chain_note: 'Band TH-10 (R 500 000 - R 5 000 000). Risk routing added: Compliance.',
    chain: [
      { label: 'CFO', tone: 'teal' },
      { label: 'Compliance', tone: 'orange', suffix: 'RISK ROUTING' }
    ],
    verdict_title: 'Approval verdict',
    verdict_body: 'Actually approved by: CFO + Compliance',
    verdict_tone: 'bg-success-subtle text-success-emphasis',
    trace_title: 'Routing trace - across modules',
    trace: [
      { title: 'Procurement module', tag: 'REQ-204', subtitle: 'Award above R 500k with a deviation (2 of 3 quotes)' },
      { title: 'Delegation of Authority', tag: 'TH-10 + RR-05', subtitle: 'Chain computed: CFO + Compliance (deviation routing)' },
      { title: 'My Tasks', tag: '2 approval tasks', subtitle: 'Assigned to CFO and Compliance' },
      { title: 'Evidence vault', tag: 'RFQ pack', subtitle: 'Approval + deviation memo stored' },
      { title: 'Reports', tag: 'SCM register', subtitle: 'Logged as within authority' }
    ],
    footer_label: 'Open IT hardware RFQ',
    footer_icon: 'bi-box-arrow-up-right'
  },
  dc_118: {
    section: 'DECISION - DC-118',
    title: 'Payment release - GreenBuild invoice',
    subtitle: 'R 420 000 - General expenditure - routed 2 days ago',
    status: 'Within authority',
    status_class: 'bg-success-subtle text-success-emphasis',
    chain_label: 'Required approver chain',
    chain_note: 'Band TH-02 (R 50 000 - R 500 000). No risk routing triggered.',
    chain: [{ label: 'Executive (CFO)', tone: 'teal' }],
    verdict_title: 'Approval verdict',
    verdict_body: 'Actually approved by: Executive (CFO)',
    verdict_tone: 'bg-success-subtle text-success-emphasis',
    trace_title: 'Routing trace - across modules',
    trace: [
      { title: 'Finance module', tag: 'INV-2204', subtitle: 'Payment R 420 000 reaches the gate' },
      { title: 'Delegation of Authority', tag: 'TH-02', subtitle: 'Chain computed: Executive (CFO)' },
      { title: 'Evidence vault', tag: 'Payment record', subtitle: 'Approval stored' },
      { title: 'Reports', tag: 'Finance register', subtitle: 'Within authority' }
    ],
    footer_label: 'Open GreenBuild invoice',
    footer_icon: 'bi-box-arrow-up-right'
  },
  dc_150: {
    section: 'DECISION - DC-150',
    title: 'Platform support agreement renewal',
    subtitle: 'R 520 000 - Contract value - routed 3 days ago',
    status: 'Outside authority',
    status_class: 'bg-danger-subtle text-danger-emphasis',
    chain_label: 'Required approver chain',
    chain_note: 'Band TH-13 (R 500 000 - R 5 000 000). Risk routing added: Compliance, Internal Audit.',
    chain: [
      { label: 'CFO', tone: 'teal' },
      { label: 'CEO', tone: 'teal' }
    ],
    verdict_title: 'Approval verdict',
    verdict_body: 'Actually approved by: M. Khan (CFO) - logged as exception EX-01',
    verdict_tone: 'bg-danger-subtle text-danger-emphasis',
    trace_title: 'Routing trace - across modules',
    trace: [
      { title: 'Contract module', tag: 'CTR-118', subtitle: 'Renewal R 520 000 above CFO-only threshold' },
      { title: 'Delegation of Authority', tag: 'TH-13', subtitle: 'Chain required: CFO + CEO - CEO co-sign missing' },
      { title: 'Exception log', tag: 'EX-01', subtitle: 'Outside authority - escalated to CEO for ratification' },
      { title: 'Reports', tag: 'Exception register', subtitle: 'Flagged outside authority' }
    ],
    footer_label: 'Open platform renewal',
    footer_icon: 'bi-box-arrow-up-right'
  },
  dc_160: {
    section: 'DECISION - DC-160',
    title: 'Data-sharing agreement - BlueData',
    subtitle: 'General expenditure - routed today - 11:40',
    status: 'Awaiting approval',
    status_class: 'bg-warning-subtle text-warning-emphasis',
    chain_label: 'Required approver chain',
    chain_note: 'Band TH-01 (R 0 - R 50 000). Risk routing added: Compliance, Internal Audit, Legal, Information Officer.',
    chain: [
      { label: 'Line manager', tone: 'teal' },
      { label: 'Compliance', tone: 'orange', suffix: 'RISK ROUTING' },
      { label: 'Internal Audit', tone: 'orange', suffix: 'RISK ROUTING' },
      { label: 'Legal', tone: 'orange', suffix: 'RISK ROUTING' },
      { label: 'Information Officer', tone: 'orange', suffix: 'RISK ROUTING' }
    ],
    verdict_title: 'Approval verdict',
    verdict_body: 'Actually approved by: -- not yet approved',
    verdict_tone: 'bg-warning-subtle text-warning-emphasis',
    trace_title: 'Routing trace - across modules',
    trace: [
      { title: 'Data privacy module', tag: 'DSA-09', subtitle: 'Personal data sharing proposed - no manual approver allowed' },
      { title: 'Delegation of Authority', tag: 'RR-01 + RR-04', subtitle: 'Risk routing pulls in Legal, Information Officer, Compliance & Internal Audit' },
      { title: 'My Tasks', tag: '4 approval tasks', subtitle: 'Assigned to the full chain' },
      { title: 'Evidence vault', tag: 'Pending DPA', subtitle: 'Signed DPA required before sharing' }
    ],
    footer_label: 'Open BlueData agreement',
    footer_icon: 'bi-box-arrow-up-right'
  }
};


